import dc from '../lib/directchat_lib';

export default class WatchDog {
  constructor(el) {

  }

  /* eslint-disable class-methods-use-this */
  // Watch for new chat entries.
  startWatchChatDog(duration) {
    let i = 0;
    this.chat = setInterval(
      () => {
        // Watch for chat updates or invitations.
        dc.checkChatState();
        i += i;
      },
      duration !== undefined ? duration : this.watchChatDuration
    );
  }

  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/treff_watchdog.js